// Angular
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
// RxJS
import { BehaviorSubject, Observable, of } from "rxjs";
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from "../../_base/crud";
import { ProductGroupModel } from "../_models/product-group.model";
import { catchError } from "rxjs/operators";
import { environment } from "../../../../environments/environment";
// Models

const API_PRODUCTS_URL = environment.API_URL + "api/productGroups";

// Real REST API
@Injectable({
  providedIn: "root"
})
export class ProductGroupsService {
  lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, "asc", "", 0, 10));

  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {}

  // CREATE =>  POST: add a new productGroup to the server
  createProductGroup(productGroup): Observable<ProductGroupModel> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http
      .post<ProductGroupModel>(API_PRODUCTS_URL, productGroup, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }

  // READ
  getAllProductGroups(): Observable<ProductGroupModel[]> {
    return this.http.get<ProductGroupModel[]>(API_PRODUCTS_URL).pipe(catchError((err) => of(null)));
  }

  getProductGroupById(productGroupId: number): Observable<ProductGroupModel> {
    return this.http
      .get<ProductGroupModel>(API_PRODUCTS_URL + `/${productGroupId}`)
      .pipe(catchError((err) => of(null)));
  }

  // Server should return filtered/sorted result
  findProductGroups(queryParams: QueryParamsModel): Observable<QueryResultsModel> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();

    const url = API_PRODUCTS_URL + "/find";
    return this.http
      .post<QueryResultsModel>(url, queryParams, {
        headers: httpHeaders
      })
      .pipe(catchError((err) => of(null)));
  }

  // UPDATE => PUT: update the productGroup on the server
  updateProductGroup(productGroup: ProductGroupModel): Observable<any> {
    // Note: Add headers if needed (tokens/bearer)
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    return this.http
      .put(`${API_PRODUCTS_URL}/${productGroup.id}`, productGroup, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }

  // UPDATE Status
  // Comment this when you start work with real server
  // This code imitates server calls
  updateStatusForProductGroup(productGroups: ProductGroupModel[], status: number): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = {
      productGroupsForUpdate: productGroups,
      newStatus: status
    };
    const url = API_PRODUCTS_URL + "/updateStatus";
    return this.http.put(url, body, { headers: httpHeaders }).pipe(catchError((err) => of(null)));
  }

  // DELETE => delete the productGroup from the server
  deleteProductGroup(productGroupId: number): Observable<ProductGroupModel> {
    const url = `${API_PRODUCTS_URL}/${productGroupId}`;
    return this.http.delete<ProductGroupModel>(url).pipe(catchError((err) => of(null)));
  }

  deleteProductGroups(ids: number[] = []): Observable<any> {
    const url = API_PRODUCTS_URL + "/delete";
    const httpHeaders = this.httpUtils.getHTTPHeaders();
    const body = { prdocutIdsForDelete: ids };
    return this.http
      .put<QueryResultsModel>(url, body, { headers: httpHeaders })
      .pipe(catchError((err) => of(null)));
  }
}
